import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useFormikContext } from "formik";
import { useDispatch } from "react-redux";
import {
  CREATE_PAYMENT_INTENT_GROUP_ORDER,
  UPDATE_PAYMENT_INTENT_GROUP_ORDER,
} from "../../../store/Common/Common.constant";
import LocationSearchInput from "../../../modules/ui/LocationSearchInput";
import {
  FORM_CREATE_GO_SET_VAL,
  FORM_INVALID_FIELDS,
} from "../../../store/Form/Form.constant";
import Accordion from "../../../modules/ui/Accordion";
import FormInput from "../../../modules/ui/Form/FormInput";
import FormInputAdd from "../../../modules/ui/Form/FormInput/FormInputAdd";
import FormTextarea from "../../../modules/ui/Form/FormTextarea";
import getDistanceFromLatLonInKm from "../../../hooks/getDistanceFromLatLonInKm";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import AnimatedLoader from "../../../modules/ui/animatedLoader";
import getTimestampFromDateAndTime from "../../../hooks/getTimestampFromDateAndTime";
import { Truck, ArrowRight, MapPin, Building2, FileText } from "lucide-react";

const Delivery = ({ edit, uuid, loading, pathname, groupOrders }) => {
  const { values, setFieldValue } = useFormikContext();
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const isUpdateable =
    edit &&
    (groupOrders?.company_name !== values?.company_name ||
      groupOrders?.delivery_address !== values?.delivery_address ||
      groupOrders?.delivery_suite !== values?.delivery_suite ||
      groupOrders?.delivery_instruction !==
        (values?.delivery_instruction || ""));
  const dispatch = useDispatch();
  let validate = () => {
    if (
      Object.values(values).length &&
      !values.per_person_budget &&
      !values.head_count &&
      !values.name &&
      !(values.confirm?.[0] === "yas")
    ) {
      return window.location.replace(pathname + "#team");
    }
  };
  useEffect(validate, [values]);
  const onLoadInfo = () => {
    setFieldValue(
      "delivery_address",
      groupOrders?.delivery_address || values?.delivery_address || ""
    );
    setFieldValue(
      "company_name",
      groupOrders?.company_name || values?.company_name || ""
    );
    groupOrders?.delivery_suite &&
      !values?.delivery_suite &&
      setFieldValue("delivery_suite", groupOrders?.delivery_suite);
    groupOrders?.delivery_instruction &&
      !values?.delivery_instruction &&
      setFieldValue("delivery_instruction", groupOrders?.delivery_instruction);
    if (groupOrders?.additional_delivery_options?.length) {
      setFieldValue("storey", groupOrders?.additional_delivery_options);
      setFieldValue("isStorey", true);
    }
  };
  useEffect(onLoadInfo, [groupOrders]);

  const onClickContinue = () => {
    if (values.delivery_address && values.company_name && !loading) {
      let {
        date,
        time,
        confirm,
        isStorey,
        storey,
        deadlineDate,
        deadlineTime,
        ...val
      } = values;
      if (
        getTimestampFromDateAndTime(deadlineDate, deadlineTime) >=
        getTimestampFromDateAndTime(date, time)
      ) {
        dispatch({
          type: FORM_INVALID_FIELDS,
          payload: {
            form: "delivery",
            message:
              "Order deadline cannot be later than the delivery date/time",
          },
        });
        window.location.replace(pathname + "#team");
        return;
      }
      dispatch({
        type: FORM_CREATE_GO_SET_VAL,
        payload: { values: values, uuid: uuid },
      });
      // if (!isUpdateable) {
      val.delivery_date_time = date.setHours(
        time.split(/[\s:]+/)[2] === "PM" && +time.split(/[\s:]+/)[0] !== 12
          ? +time.split(/[\s:]+/)[0] + 12
          : +time.split(/[\s:]+/)[0],
        time.split(/[\s:]+/)[1],
        0
      );
      val.order_deadline = deadlineDate.setHours(
        deadlineTime.split(/[\s:]+/)[2] === "PM" &&
          +deadlineTime.split(/[\s:]+/)[0] !== 12
          ? +deadlineTime.split(/[\s:]+/)[0] + 12
          : +deadlineTime.split(/[\s:]+/)[0],
        deadlineTime.split(/[\s:]+/)[1],
        0
      );

      dispatch({
        type: isUpdateable
          ? UPDATE_PAYMENT_INTENT_GROUP_ORDER
          : CREATE_PAYMENT_INTENT_GROUP_ORDER,
        payload: {
          group_order: {
            ...val,
            additional_delivery_options: isStorey ? storey : [],
          },
          id: groupOrders?.id,
          uuid: uuid,
          redirect: pathname + "#payment",
        },
      });
    } else {
      setSubmitSuccess(true);
    }
  };

  const chef = groupOrders?.preset?.chefs?.[0];
  let distanceDelivery =
    getDistanceFromLatLonInKm(
      +chef?.latitude,
      +chef?.longitude,
      +values?.delivery_latitude,
      +values?.delivery_longitude
    ) < chef?.max_delivery_distance;

  if (!values?.delivery_latitude && values?.delivery_address) {
    geocodeByAddress(values?.delivery_address)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        setFieldValue("delivery_latitude", latLng.lat);
        setFieldValue("delivery_longitude", latLng.lng);
      })
      .catch((error) => console.error("Error", error));
  }

  return (
    <>
      <AnimatedLoader isLoading={loading} />
      <div className="head__form delivery__head">
        <span className="form__section-icon delivery__head-icon">
          <Truck size={24} />
        </span>
        <div className="delivery__head-text">
          <h2>Delivery Details</h2>
          <p>
            Complete your delivery information so we can get your order to
            the right place.
          </p>
        </div>
        <img
          className="delivery__illustration"
          src="/img/panda-delivery.png"
          alt=""
        />
      </div>
      <div className="form__section">
      <div className="form__section-header">
        <span className="form__section-icon">
          <MapPin size={20} />
        </span>
        <div>
          <h3>Delivery Location</h3>
          <p>Where should we bring the order?</p>
        </div>
      </div>
      <div className="hidden__content">
        <div className="double__field">
          <div className="form__group">
            <p>Company Name*</p>
            <div className="icon__field">
              <Building2 className="field__icon" size={16} />
              <FormInput
                error={submitSuccess && !values.company_name}
                required={true}
                placeholder="Acme Inc."
                classContainer="form__field"
                type="text"
                name="company_name"
              />
            </div>
          </div>
          <div className="form__group">
            <p>Full Address*</p>
            <div className="icon__field">
              <MapPin className="field__icon" size={16} />
              {values?.delivery_address || values?.delivery_address === "" ? (
                <LocationSearchInput
                  error={submitSuccess && !values.delivery_address}
                  value={values.delivery_address}
                  name="delivery_address"
                  setFieldValue={setFieldValue}
                />
              ) : null}
            </div>
          </div>
        </div>
        {values?.delivery_address && !distanceDelivery ? (
          <div className="form__error">
            You are too far from the establishment, maximum range is{" "}
            {chef?.max_delivery_distance}km (
            {(chef?.max_delivery_distance / 1.609344).toFixed(2)} miles) from{" "}
            {`${chef?.address1}, ${chef?.city}, ${chef?.country}`}
          </div>
        ) : null}
        <div className="double__field">
          <div className="form__group">
            <p>Suite / Floor (Optional)</p>
            <div className="icon__field">
              <Building2 className="field__icon" size={16} />
              <FormInput
                placeholder="e.g. Suite 200"
                classContainer="form__field"
                type="text"
                name="delivery_suite"
              />
            </div>
          </div>
          <div className="form__group">
            <p>Delivery Instructions (Optional)</p>
            <div className="icon__field">
              <FileText className="field__icon" size={16} />
              <FormTextarea
                classContainer="form__field"
                name="delivery_instruction"
                placeholder="e.g. Leave at front desk"
                rows={1}
              />
            </div>
          </div>
        </div>
      </div>
      </div>
      <div className="form__section floor__delivery-section">
        <div className="floor__delivery-accordion">
          <span className="form__section-icon">
            <Building2 size={20} />
          </span>
          <div className="accordion__body">
            <Accordion
              disabled={edit}
              defaultToggle={values?.isStorey}
              modal={true}
              name="isStorey"
              title="Floor Delivery (Optional)"
              modalTitle="Are you sure you want to close this? If this selection is closed then all selections will be removed? Proceed?"
            >
              <p>
                If your office has multiple floors, add the floor numbers
                below. This helps us deliver the food to the correct floors
                when your team members start joining the order.
              </p>
              <FormInputAdd name="storey" />
            </Accordion>
          </div>
        </div>
      </div>
      <div className="form__submit">
        <button
          disabled={!distanceDelivery}
          onClick={onClickContinue}
          type="button"
        >
          {isUpdateable ? "Update" : "Continue"}
          <ArrowRight size={18} />
        </button>
      </div>
      <div className="form__back">
        <NavLink to={pathname + "#team"}>Back</NavLink>
      </div>
    </>
  );
};
export default Delivery;
